import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { pt } from 'vuetify/lib/locale'
import { en } from 'vuetify/lib/locale'

Vue.use(Vuetify)

export default new Vuetify({
  // Textos padrão do Vuetify (paginação, "sem dados", calendário) em português
  lang: {
    locales: { pt, en },
    current: 'pt'
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        // Mesma identidade do site (azul-marinho e cobre da logo)
        primary: '#012a4a',
        secondary: '#FFFFFF',
        navyDeep: '#001c31',
        copper: '#c98450',
        cream: '#f6f3ee',
        ink: '#17242e',
        muted: '#66737c',
        gray: '#F4F5F7',
        lightGray: '#EEF0F3',
        black: '#17242e',
        mediumGray: '#8a949b',
        darkGray: '#66737c',
        important: '#c98450',
        lightImportant: '#FBF4EE',
        white: '#FFFFFF',
        accent: '#2e8b57',
        success: '#2e8b57',
        warning: '#d98a1c',
        error: '#c94a4a',
        info: '#2f6f9f'
      }
    }
  }
})
